import { useState } from "react";
import styled, { keyframes } from "styled-components";
import {t} from '@lingui/core/macro';
import { signInApiCall } from "../Api.js"
import toast from 'react-hot-toast';
const jump = keyframes`
  from{
    transform: translateY(0)
  }
  to{
    transform: translateY(-3px)
  }
`;


const Form = styled.form`
  margin: 0 auto;
  width: 90%;
  max-width: 414px;
  padding: 1.3rem;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Input = styled.input`
  max-width: 100%;
  padding: 11px 13px;
  background: #f9f9fa;
  color: #f03d4e;
  margin-bottom: 0.9rem;
  border-radius: 4px;
  outline: 0;
  border: 1px solid rgba(245, 245, 245, 0.7);
  font-size: 14px;
  transition: all 0.3s ease-out;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1), 0 1px 1px rgba(0, 0, 0, 0.1);
  :focus,
  :hover {
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.15), 0 1px 5px rgba(0, 0, 0, 0.1);
  }
`;

const Button = styled.button`
  max-width: 100%;
  padding: 11px 13px;
  color: rgb(253, 249, 243);
  font-weight: 600;
  text-transform: uppercase;
  background: #f03d4e;
  border: none;
  border-radius: 3px;
  outline: 0;
  cursor: pointer;
  margin-top: 0.6rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-out;
  &:hover {
    background: rgb(200, 50, 70);
    animation: ${jump} 0.2s ease-out forwards;
  }
`;

/**
 * A component to display a user login form
 * @param {object} props
 * @param {fuction} props.handleSubmission A function that handles a successful login
 * @returns {JSX.Element}
 */
const FormSignin = ({ handleSubmission }) => {
  const [login, setLogin] = useState({
    email: "",
    password: ""
  });

  /**
   * A function that handles a signin api call 
   * @param {object} e - An event dom object
   * @returns {void} Show an UI result and call a local storage function
   */
  const handleSubmitSignin = e => {
    e.preventDefault();
    signInApiCall(login).then(data => {
      if (data.success) {
        //set current login info cookie
        localStorage.setItem("isAuthenticated", true);
        toast(t`Logged in successfully!`, {
          icon: '👋',
        });
        handleSubmission();
      } else {
        toast(data.error.message || t`Generic login error`, {
          icon: '🥵',
        });
      }
    }
    )
      .catch(error => {
        console.error(error);
      });
  };

  /**
   * A function that handles a user form change
   * @param {object} e - An event dom object
   * @returns {void} Set state variables
   */
  const handleChange = e => {
    e.preventDefault();
    const { name, value } = e.target;
    setLogin({ ...login, [name]: value })
  };


  return (
    <Form onSubmit={handleSubmitSignin}>
      <Input
        type="email"
        name="email"
        placeholder="Email"
        value={login.email}
        onChange={handleChange}
      />
      <Input
        type="password"
        name="password"
        placeholder="Password"
        value={login.password}
        onChange={handleChange}
      />
      <Button>{t`Login`}</Button>
    </Form>
  );
}

export default FormSignin;
